/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { GatsbyImage } from 'gatsby-plugin-image';
import { determineKind, kindClass } from '../../helpers/determine-kind';
import { gtmPush } from '../global/gtm-push';
import Modal from '../modal/modal';
import SingleEventFull from './single-event-full';
import './_single-event.scss';

const SingleEvent = ({
  data, title, external, ap, setData, filterData, eventsData, categoriesData, facetsData, embedded,
}) => {
  const singleData = data.data;
  const modalRef = useRef();
  const itemRef = useRef(null);
  let externalUrl = '';
  if (typeof window !== 'undefined') {
    externalUrl = `${window.location.protocol}//${window.location.host}/event/${data.fields.slug}`;
  }
  // TODO function to determine category or categories of crime
  const kind = determineKind(data, 'Warcrime_Category', categoriesData);
  const facets = determineKind(data, 'Warcrime_Facet', facetsData);
  const [hover, setHover] = useState(false);
  const [overRight, setOverRight] = useState(false);
  const [overTop, setOverTop] = useState(false);
  const incidentDate = new Date(singleData.Incident_Date);
  incidentDate.setDate(incidentDate.getDate() + 1);
  const incidentDateStr = incidentDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  const positionHover = (currentTarget) => {
    const currentChild = currentTarget.querySelector('.single-event__more');
    if (currentChild) {
      const currentChildBounds = currentChild.getBoundingClientRect();
      const wrapper = document.getElementById('gatsby-focus-wrapper');
      const wrapperBounds = wrapper.getBoundingClientRect();
      if (currentChildBounds.right > wrapperBounds.right) {
        if (!currentTarget.classList.contains('over-right')) {
          setOverRight(true);
        }
      }
      if (currentChildBounds.top < 0) {
        setOverTop(true);
      }
    }
  };

  const handleHoverIn = (event) => {
    const modal = document.querySelector('.modal');
    if (modal) {
      setHover(false);
    } else {
      const { currentTarget } = event;
      positionHover(currentTarget);
      setHover(true);
      gtmPush(
        'hover',
        (embedded ? 'Embedded hover' : 'Main hub hover'),
      );
    }
  };

  const handleHoverOut = () => {
    setHover(false);
  };

  const handleClick = (e) => {
    const closest = e.target.closest('.single-event');
    if (closest) {
      if (closest.classList.contains('hover')) {
        modalRef.current.openModal();
        setHover(false);
        gtmPush(
          'click',
          (embedded ? 'Embedded click- full event from embed' : 'Embedded click- full event from main hub'),
        );
      }
    }
    if (isMobile) {
      handleHoverIn(e);
    }
  };

  useEffect(() => {
    positionHover(itemRef.current);
  }, []);

  useEffect(() => {
    setOverRight(false);
    setOverTop(false);
    positionHover(itemRef.current);
  }, [eventsData]);
  return (
    <div
      className={`single-event ${(!kind.unique ? 'single-event--multiple-categories' : '')} ${kindClass(kind.items)} ${kindClass(facets.items)} ${(hover ? 'hover' : '')} ${(overRight ? 'over-right' : '')} ${(overTop ? 'over-top' : '')}`}
      onFocus={(e) => handleHoverIn(e)}
      onBlur={() => handleHoverOut()}
      onMouseEnter={(!isMobile ? (e) => handleHoverIn(e) : () => false)}
      onMouseLeave={() => handleHoverOut()}
      onClick={(e) => handleClick(e)}
      ref={itemRef}
    >
      <div className="single-event__icon-container">
        {kind.items.map((category, index) => (
          <div className={`single-event__icon single-event__icon--${category.slug}`} key={index} />
        ))}
      </div>
      {kind.items.map((category, index) => (
        <p className="single-event__category" key={index}>{category?.label}</p>
      ))}
      {(singleData.Incident_Date || singleData.Location
        ? (
          <div className="single-event__dateTime">
            {incidentDateStr}
            {(singleData.Location ? ` • ${singleData.Location}` : false)}
          </div>
        ) : false)}
      {(external)
        ? (
          <div className="single-event__more">
            <a href={externalUrl} target="_blank" rel="noreferrer">
              <div className="single-event__more-details">
                {(data.fields.localMainImage ? (
                  <div className="event__image">
                    <GatsbyImage image={data.fields.thumbnail.childImageSharp.gatsbyImageData} alt="" />
                  </div>
                ) : false)}
                {(singleData.Publish_Title ? <div className="single-event__summary">{singleData.Publish_Title}</div> : false)}
              </div>
              <a className="single-event__link" href={externalUrl} target="_blank" rel="noreferrer">View More</a>
            </a>
          </div>
        ) : (
          <div className="single-event__more">
            <div className="single-event__more-details">
              {(data.fields.localMainImage ? (
                <div className="event__image">
                  <GatsbyImage image={data.fields.thumbnail.childImageSharp.gatsbyImageData} alt="" />
                </div>
              ) : false)}
              {(singleData.Publish_Title ? <div className="single-event__summary">{singleData.Publish_Title}</div> : false)}
            </div>
            <span className="single-event__link">View More</span>
          </div>
        )}
      <Modal ref={modalRef}>
        <SingleEventFull
          data={data}
          title={title}
          ap={ap}
          modalRef={modalRef}
          setData={setData}
          filterData={filterData}
          eventsData={eventsData}
          embedded={embedded}
        />
      </Modal>
    </div>
  );
};

export default SingleEvent;

SingleEvent.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  external: PropTypes.bool,
  ap: PropTypes.bool,
  embedded: PropTypes.bool,
  filterData: PropTypes.func,
  eventsData: PropTypes.object,
  categoriesData: PropTypes.array.isRequired,
  facetsData: PropTypes.array.isRequired,
  setData: PropTypes.func,
};

SingleEvent.defaultProps = {
  external: false,
  ap: false,
  embedded: false,
  filterData: (() => null),
  eventsData: {},
  setData: (() => null),
};
